import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useContext, useEffect } from 'react';
import { PropTypes, describe } from 'react-desc';
import styled from 'styled-components';
import { PopperPositions } from '@elliemae/ds-popper';
import { TruncatedTooltipContext } from './TooltipTextProvider.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@elliemae/ds-popover';

var isEllipsisActive = function isEllipsisActive(_ref) {
  var offsetWidth = _ref.offsetWidth,
      scrollWidth = _ref.scrollWidth;
  return offsetWidth < scrollWidth;
}; // reduce the possibility of error showing the tooltip (text-overflow: ellipsis) https://jira.elliemae.io/browse/PUI-1755


var Text = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-1olo1o7-0"
})(["text-overflow:ellipsis;white-space:nowrap;overflow:hidden;display:inline-block;max-width:100%;"]);

var DSTruncatedTooltipText = function DSTruncatedTooltipText(_ref2) {
  var _ref2$containerProps = _ref2.containerProps,
      containerProps = _ref2$containerProps === void 0 ? {} : _ref2$containerProps,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? '' : _ref2$value,
      _ref2$zIndex = _ref2.zIndex,
      zIndex = _ref2$zIndex === void 0 ? 110 : _ref2$zIndex,
      otherTextProps = _objectWithoutProperties(_ref2, ["containerProps", "value", "zIndex"]);

  var tooltipContext = useContext(TruncatedTooltipContext);
  useEffect(function () {
    if (zIndex && tooltipContext) tooltipContext.setZIndex(zIndex);
  }, [zIndex]);
  if (!tooltipContext) return value;
  var showTooltip = tooltipContext.showTooltip,
      hideTooltip = tooltipContext.hideTooltip;

  var handleMouseEnter = function handleMouseEnter(e) {
    var target = e.target;

    if (target && isEllipsisActive(target, target.getBoundingClientRect())) {
      showTooltip({
        value: value,
        reference: target
      }, e);
    }
  };

  var handleMouseLeave = function handleMouseLeave(e) {
    hideTooltip({
      reference: e.target
    });
  };

  var handlers = showTooltip ? {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  } : {};
  return /*#__PURE__*/React.createElement(Text, _extends({}, containerProps, otherTextProps, handlers), value);
};

DSTruncatedTooltipText.defaultProps = {
  value: '',
  zIndex: 110
};
var truncatedTooltipTextProps = {
  containerProps: PropTypes.object.description('Set of Properties attached to the main container'),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).description('Text that when truncated will trigger the tooltip interaction'),
  tooltipPlacement: PropTypes.oneOf([PopperPositions.AUTO_START, PopperPositions.AUTO_END, PopperPositions.AUTO, PopperPositions.TOP_START, PopperPositions.TOP, PopperPositions.TOP_END, PopperPositions.RIGHT_START, PopperPositions.RIGHT, PopperPositions.RIGHT_END, PopperPositions.BOTTOM_START, PopperPositions.BOTTOM, PopperPositions.BOTTOM_END, PopperPositions.LEFT_START, PopperPositions.LEFT, PopperPositions.LEFT_END]).description('Position of the tooltip'),
  tooltipDelay: PropTypes.number.description('Delay to show the tooltip'),
  zIndex: PropTypes.number.description('override default zIndex').defaultValue(110)
};
DSTruncatedTooltipText.defaultProps = {
  containerProps: {},
  value: '',
  tooltipPlacement: undefined,
  tooltipDelay: undefined
};
DSTruncatedTooltipText.propTypes = truncatedTooltipTextProps;
var TruncatedTooltipTextWithSchema = describe(DSTruncatedTooltipText);
TruncatedTooltipTextWithSchema.propTypes = truncatedTooltipTextProps;

export default DSTruncatedTooltipText;
export { DSTruncatedTooltipText, TruncatedTooltipTextWithSchema };
//# sourceMappingURL=DSTruncatedTooltipText.js.map
